/**
 * Getters of the store inbound-sms module.
 *
 * @module store/inbound-sms/getters
 * @author Dilan Useche <dilan8810@gmail.com>
 * */
export default {
};
